import Papa from "papaparse";

const extractFields = (obj, parent_key = "") => {
  let fields = {};
  Object.keys(obj).forEach((key) => {
    if ((obj[key] || obj[key] === 0) && key !== "_highlightResult") {
      let newKey = parent_key ? `${parent_key}_${key}` : key;
      if (typeof obj[key] === "object" && obj[key] !== null) {
        // If the value is an object, recursively extract fields
        const nestedFields = extractFields(obj[key], newKey);
        fields = { ...fields, ...nestedFields };
      } else {
        // If the value is not an object, add it to the fields
        fields[newKey] = obj[key];
      }
    }
  });
  return fields;
};

const formatArrayForCsv = (arr) => {
  let data = [];
  arr.forEach((arr_item) => {
    let fields = extractFields(arr_item);
    data.push(fields);
  });
  return data;
};

export const parseArrayToCsv = (arr = [], filename) => {
  if (arr.length === 0) return;

  const data = formatArrayForCsv(arr);
  const csv = Papa.unparse(data);
  // Create a Blob with the CSV data
  const blob = new Blob([csv], { type: "text/csv" });
  // Create a download link
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  // Trigger a click on the link to start the download
  link.click();
};
